/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import clsx from 'clsx';

import BaseComponent from './BaseComponent';

const VisibilitySensorClass = VisibilitySensor as any;

interface Props {
  orElse: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  preload?: boolean;
}

interface State {
  loaded: boolean;
}

export default class Lazy extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loaded: !!props.preload,
    };
  }

  handleChangeVisibility(isVisible: boolean) {
    if (isVisible) {
      this.setState({
        loaded: true,
      });
    }
  }

  render() {
    const { children, className: classNameFromProps, orElse } = this.props;

    const { loaded } = this.state;

    const className = clsx('Lazy', classNameFromProps, {
      'is-loaded': loaded,
    });

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const actualChildren = loaded ? children! : orElse;

    return (
      <VisibilitySensorClass
        active={!loaded}
        className={className}
        intervalCheck={true}
        intervalDelay={250}
        offset={{ top: 32, left: 32 }}
        onChange={this.handleChangeVisibility}
        partialVisibility={true}
        resizeCheck={true}
        scrollCheck={true}
        scrollThrottle={25}
        delayedCall={true}
      >
        {actualChildren}
      </VisibilitySensorClass>
    );
  }
}
